import { useIntl } from "react-intl";

import { parseDuration } from "@/utils/duration";

import {
  FlightInfo,
  type FlightInfoProps,
  FlightOverallTime,
} from "./flights/FlightInfo";

type Props = Pick<FlightInfoProps, "origin" | "destination"> & {
  duration: string | null;
  stops: number;
  operatedBy?: string;
};

export const SingleFlightInfo = ({
  origin,
  destination,
  duration,
  stops,
  operatedBy,
}: Props) => {
  const intl = useIntl();

  return (
    <FlightInfo origin={origin} destination={destination}>
      <div className="flex flex-col">
        <FlightOverallTime
          overallTime={
            duration
              ? intl.formatMessage(
                  {
                    id: "durationValue",
                    defaultMessage: "{hours}h {minutes}m",
                  },
                  parseDuration(duration),
                )
              : null
          }
          stops={stops}
        />
        {operatedBy ? (
          <div className="text-center text-sm text-text-tertiary">{`${intl.formatMessage({ id: "flights.flightOperatedBy", defaultMessage: "Flight operated by" })} ${operatedBy}`}</div>
        ) : null}
      </div>
    </FlightInfo>
  );
};
